import ROUTE_PATH from 'routes/config';

const { serviceView } = ROUTE_PATH;

export const AIZEN_FOOTER_PATH = [serviceView];
